<template>
    <tickets-structure v-if="setUpTickets" :key="selectedDate"></tickets-structure>
</template>

<script lang='ts'>
    import { Vue } from "vue-property-decorator";
    import { Component } from "vue-property-decorator";
    import moment from 'moment-timezone';
    import TicketsStructure from '../ticket-structure/TicketsStructure.vue';
    import TicketWidgetComponent from '../../TicketWidgetComponent';

    @Component({
        components: {
            TicketsStructure
        }
    })

    export default class Tickets extends TicketWidgetComponent {
        selectedDate: any = null;
        setUpTickets: boolean = false;

        mounted() {
            this.setUp();
        }

        setUp() {
            // if there is an occurrence and event, then set up tickets
            if(this.selectedOccurrence && this.selectedEvent) {
                this.selectedDate = this.selectedOccurrence.date_friendly;
                this.setUpTickets = true;
            }

            // add listener for when a date has been selected
            this.$root.$on('dateSelected', (dateSelected: any) => {
                this.selectedDate = dateSelected.date_friendly;
                this.setUpTickets = true;
            });

            // add listener for when an event has been selected
            this.$root.$on('eventSelected', () => {
                this.setUpTickets = false;
            });
        }
    }
</script>